import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  image: {
    height: 250,
  },
  border: {
    border: 'solid',
  },
  fullHeightCard: {
    height: '100%',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderBottom: '10px solid white',
    height: '100%',
    position: "relative",
    zIndex: -100
  },
  activeCard: {
    borderBottom: '10px solid #22289a',
  },
  desc: {
    padding: '20px 20px'
  },
  grid: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '20px',
  },
  title: {
    padding: '0 16px',
    lineHeight: '100%',
  },
  cardActions: {
    padding: '0 16px 8px 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});